module.exports = __webpack_public_path__ + "img/logout.4a74aa3f.svg";